import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getPostCode = createAsyncThunk('/GetPostCodeRequest', async (params) => {
    const response = await axios.get(`/GetPostCodeRequest/${params[0]}/${params[1]}`);
    return response.data;
});
export const getRegion = createAsyncThunk('/GetRegionRequest', async () => {
    const response = await axios.get(`/GetRegionRequest`);
    return response.data;
});
export const getCityRequestByRegion = createAsyncThunk('/GetCityRequestByRegion', async (regionName) => {
    const response = await axios.get(`/GetCityRequestByRegion/${regionName}`);
    return response.data;
});
export const getCity = createAsyncThunk('/GetCityRequest', async () => {
    const response = await axios.get(`/GetCityRequest/`);
    return response.data;
});
export const getNeighborhood = createAsyncThunk('/GetNeighborhoodsRequest', async (params) => {
    const response = await axios.get(`/GetNeighborhoodsRequest/${params[0]}/${params[1]}`);
    return response.data;
});
export const getDistrict = createAsyncThunk('/GetDistrictRequest', async (params) => {
    const response = await axios.get(`/GetDistrictRequest/${params[0]}/${params[1] || '0'}`);
    return response.data;
});

export const getRegionRequestByCountryCode = createAsyncThunk('/GetRegionRequestByCountryCode', async (countryCode) => {
  const response = await axios.get(`/GetRegionRequestByCountryCode/`);
  return response.data;
});

export const getCityRequestByCountryCode = createAsyncThunk('/GetCityRequestByCountryCode', async (countryCode) => {
  const response = await axios.get(`/GetCityRequestByCountryCode/`);
  return response.data;
});

const addressSlice = createSlice({
    name: 'address',
    initialState: {
        loading: '',
        error: '',
        PostCode: [],
        Region: [],
        City: [],
        Neighborhood: [],
        District: [],
        RegionByCountyCode:[],
        CityByCountyCode:[]
    },
    reducers: {
    },
    extraReducers: {
        [getPostCode.pending]: (state) => {
            state.loading = 'Loading';
        },
        [getPostCode.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [getPostCode.fulfilled]: (state, action) => {
            state.PostCode = action.payload;
            state.loading = 'Finished';
        },
        [getRegion.pending]: (state) => {
            state.loading = 'Loading';
        },
        [getRegion.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [getRegion.fulfilled]: (state, action) => {
            state.Region = action.payload;
            state.loading = 'Finished';
        },
        [getCity.pending]: (state) => {
            state.loading = 'Loading';
        },
        [getCity.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [getCity.fulfilled]: (state, action) => {
            state.City = action.payload;
            state.loading = 'Finished';
        },
        [getCityRequestByRegion.pending]: (state) => {
            state.loading = 'Loading';
        },
        [getCityRequestByRegion.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [getCityRequestByRegion.fulfilled]: (state, action) => {
            state.City = action.payload;
            state.loading = 'Finished';
        },
        [getNeighborhood.pending]: (state) => {
            state.loading = 'Loading';
        },
        [getNeighborhood.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [getNeighborhood.fulfilled]: (state, action) => {
            state.Neighborhood = action.payload;
            state.loading = 'Finished';
        },
        [getDistrict.pending]: (state) => {
            state.loading = 'Loading';
        },
        [getDistrict.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [getDistrict.fulfilled]: (state, action) => {
            state.District = action.payload;
            state.loading = 'Finished';
        },
        [getRegionRequestByCountryCode.pending]: (state) => {
            state.loading = 'Loading';
        },
        [getRegionRequestByCountryCode.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [getRegionRequestByCountryCode.fulfilled]: (state, action) => {
            state.RegionByCountyCode = action.payload;
            state.loading = 'Finished';
        },
        [getCityRequestByCountryCode.pending]: (state) => {
            state.loading = 'Loading';
        },
        [getCityRequestByCountryCode.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [getCityRequestByCountryCode.fulfilled]: (state, action) => {
            state.CityByCountyCode = action.payload;
            state.loading = 'Finished';
        },
    }
});

export const addressActions = addressSlice.actions;

export default addressSlice;
